import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function FullPage404() {
    const { t } = useTranslation();

    return (
        <div className="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-64 lg:px-8">
            <p className="text-lg font-semibold leading-8 text-indigo-600">404</p>
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-neutral-900 sm:text-5xl">
                {t('not_found_page__title')}
            </h1>
            <p className="mt-6 text-lg leading-7 text-neutral-600">{t('not_found_page__description')}</p>
            <div className="mt-10">
                <Link to="/" className="text-base font-semibold leading-7 text-indigo-600">
                    <span aria-hidden="true">&larr;</span> {t('not_found_page__back_home')}
                </Link>
            </div>
        </div>
    );
}
